import React, { useState } from 'react';
import './input.scss';

const Input = ({ label, name, type = 'text', register }) => {
    const [focused, setFocused] = useState(false);
    const [filled, setFilled] = useState(false);

    const handleBlur = () => {
        setFocused(false);
    };

    const handleFocus = () => {
        setFocused(true);
    };

    const handleChange = (e) => {
        setFilled(e.target.value.length > 0);
    };

    return (
        <div className="input-container">
            <div className="input-wrapper">
                <input
                    {...register(name)}
                    type={type}
                    id={name}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    className="input"
                />
                <label
                    htmlFor={name}
                    className={`input-label ${focused || filled ? 'focused' : ''}`}
                >
                    {label}
                </label>
            </div>
        </div>
    );
};

export default Input;
